import { useMutation } from '@tanstack/react-query';
import {
  AutoComplete,
  Button,
  Col,
  ConfigProvider,
  Flex,
  Row,
  Space,
  Typography,
} from 'antd';
import GoongMapApi from 'apis/goongMapApis';
import { DefaultAvatar } from 'assets/images';
import './style.css';
import {
  MarkerIcon,
  MarkerShopBludIcon,
  MarkerShopBrownIcon,
  MarkerShopNoteBludIcon,
  MarkerShopNoteBrownIcon,
  MarkerShopRedIcon,
  MarkerShopRedNoteIcon,
} from 'assets/svg';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { icons } from 'utils/constants/icons';
import TextCustom from 'components/Text/TextCustom';
import {
  calculateTimeDifferenceInMinutes,
  formatDate,
} from 'utils/constants/functions';

interface IProps {
  listLocationTeam?: any[];
  listLocationCustom?: any;
  isShowMapCustom: boolean;
}
const { LoadingOutlined } = icons;

const GoogleMap = (props: IProps) => {
  const { listLocationTeam, listLocationCustom, isShowMapCustom } = props;
  const mapIdRef = useRef<HTMLDivElement | null>(null);
  const timeOutRef = useRef<NodeJS.Timeout | null>(null);
  const infoWindowsRef = useRef<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [position, setPosition] = useState<any>();
  const [isSetup, setIsSetup] = useState(false);

  let map: google.maps.Map | null;
  let infoWindow: google.maps.InfoWindow;
  const mapRef = useRef<any>();
  const advancedMarkerElementRef = useRef<any>();
  const directionsRendererRef = useRef<any>();
  const directionsServiceRef = useRef<any>();
  // let markers: google.maps.Marker[] = [];

  const icons = [MarkerShopBrownIcon, MarkerShopBludIcon, MarkerShopRedIcon];

  const mutateGetDistanceMatrix = useMutation({
    mutationFn: GoongMapApi.getDistanceMatrix,
    onSuccess: (data) => {
      // console.log('data', data);
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  async function initMap(): Promise<void> {
    mapRef.current = (
      (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary
    ).Map;
    advancedMarkerElementRef.current = (
      (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary
    ).AdvancedMarkerElement;

    infoWindow = new google.maps.InfoWindow();

    map = new mapRef.current(document.getElementById('map') as HTMLElement, {
      center: { lat: 10.767644104951271, lng: 106.6559225320816 },
      zoom: 13,
      mapId:
        process.env.REACT_APP_GOOGLE_MAP_ID ||
        'AIzaSyA1MgLuZuyqR_OGY3ob3M52N46TDBRI_9k', //chuyển sang .env
    });

    //service vẽ đường đi
    directionsServiceRef.current = new google.maps.DirectionsService();
    directionsRendererRef.current = new google.maps.DirectionsRenderer({
      polylineOptions: {
        strokeColor: '#2651f6', // màu đuờng đi
      },
      suppressMarkers: true,
    });

    setIsSetup(true);
    setIsLoading(false);
  }

  useEffect(() => {
    initMap();
  }, []);

  useEffect(() => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
      setIsLoading(true);
    }
    timeOutRef.current = setTimeout(async () => {
      if (!isSetup) return;

      directionsRendererRef.current.setMap(null);
      deleteMarkers();
      infoWindowsRef.current = {};

      // console.log(
      //   'listLocationCustom',
      //   listLocationCustom &&
      //     (listLocationCustom?.tsalePlanningCust?.length > 0 ||
      //       listLocationCustom?.tteamSale?.length > 0),
      // );
      // Hiện thị all đi khách hàng
      if (
        listLocationCustom &&
        (listLocationCustom?.tsalePlanningCust?.length > 0 ||
          listLocationCustom?.tteamSale?.length > 0)
      ) {
        console.log('sho map listLocationCustom');
        setIsLoading(true);

        const locationTeam =
          listLocationCustom?.tteamSale
            ?.filter((item: any) => item?.latitude || item?.longitude)
            .map((item: any) => ({
              id: item.id,
              subId: item.subId,
              name: item.name,
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
            }))?.[0] || [];

        const listLocationCustomNew =
          listLocationCustom?.tsalePlanningCust
            ?.filter((item: any, index: number) => {
              item.indexNum = index + 1;
              return item?.customer?.latitude || item?.customer?.longitude;
            })
            .map((item: any) => ({
              id: item.customer.id,
              indexNum: item.indexNum,
              sapCustomerId: item.customer.sapCustomerId,
              storeName: item.customer.storeName,
              lat: parseFloat(item.customer.latitude),
              lng: parseFloat(item.customer.longitude),
              averageRevenue: item.averageRevenue,
              tcheckinout: item.tcheckinout,
              tprocessStatus: item.tprocessStatus,
            })) || [];

        map = getMapCenter(locationTeam?.lat && locationTeam?.lng);

        //tính thời gian và khoảng cách
        //marker khách hàng
        let response: any[] = [];
        if (
          locationTeam?.lat &&
          locationTeam?.lng &&
          listLocationCustomNew.length > 0
        ) {
          response = (
            await mutateGetDistanceMatrix.mutateAsync({
              origins: locationTeam,
              destinations: listLocationCustomNew,
              vehicle: 'car',
            })
          ).rows?.[0]?.elements;
          // console.log('done', response);
        }
        if (listLocationCustomNew && listLocationCustomNew?.length > 0) {
          listLocationCustomNew.forEach(
            async (location: any, index: number) => {
              location.element = response?.[index];
              // mutateGetDistanceMatrix.data?.rows?.[0].elements?.[index];
              // console.log("location['element']", location.element, response);
              await createMaker({
                location,
                isColseAll: true,
              });
            },
          );
        }

        //marker đội
        if (locationTeam?.lat && locationTeam?.lng) {
          // console.log('locationTeam', locationTeam);
          createMaker({
            location: locationTeam,
            isCustomer: false,
            isColseAll: true,
            // isShowContent: true,
          });
        }

        if (listLocationCustomNew.length === 0) {
          map?.setCenter({
            lat: locationTeam?.lat,
            lng: locationTeam?.lng,
          });
        }

        if (listLocationCustomNew.length === 1) {
          map?.setCenter({
            lat: listLocationCustomNew[0]?.lat,
            lng: listLocationCustomNew[0]?.lng,
          });
        }

        //  đường đi khách hàng
        if (listLocationCustomNew.length > 1) {
          map?.setCenter({
            lat: listLocationCustomNew[0]?.lat,
            lng: listLocationCustomNew[0]?.lng,
          });
          calculateAndDisplayRoute(
            directionsServiceRef.current,
            directionsRendererRef.current,
            listLocationCustomNew[0], // Origin
            listLocationCustomNew[listLocationCustomNew.length - 1], // Destination
            listLocationCustomNew.slice(1, -1), // Waypoints
            google.maps.TravelMode.DRIVING,
            locationTeam,
            map,
          );
          // directionsRendererRef.current.setMap(map);
        }

        showShopNote(map);
        handleTimeout();
        // setIsLoading(false);
        return;
      }

      // Hiện thị all đi đội
      if (listLocationTeam && listLocationTeam.length > 0) {
        setIsLoading(true);
        console.log('show map all Team');
        const listLocationTeamNew = listLocationTeam
          .filter((item: any) => item?.latitude || item?.longitude)
          .map((item: any) => ({
            id: item.id,
            subId: item.subId,
            name: item.name,
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
          }));

        map = getMapCenter(
          listLocationTeamNew[0]?.lat,
          listLocationTeamNew[0]?.lng,
        );
        //tạo marker
        listLocationTeamNew.forEach((location, index) => {
          // console.log('location', location);
          createMaker({
            location,
            isCustomer: false,
            isShowContent: true,
          });
        });
        setIsLoading(false);
        handleTimeout();
        return;
      }

      findMapCenter();
      setIsLoading(false);
    }, 500);
    return () => {
      if (timeOutRef.current) {
        clearTimeout(timeOutRef.current);
      }
    };
  }, [isSetup, listLocationCustom, listLocationTeam]);

  const handleTimeout = () => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  function getMapCenter(lat?: number, lng?: number, zoom = 13) {
    try {
      if (!mapRef.current && !mapIdRef.current) return null;
      return new mapRef.current(
        mapIdRef.current
          ? mapIdRef.current
          : (document.getElementById('map') as HTMLElement),
        {
          center:
            lat && lng
              ? { lat, lng }
              : { lat: 10.767644104951271, lng: 106.6559225320816 },
          zoom,
          mapId:
            process.env.REACT_APP_GOOGLE_MAP_ID ||
            'AIzaSyA1MgLuZuyqR_OGY3ob3M52N46TDBRI_9k', //chuyển sang .env
        },
      );
    } catch (e) {
      console.log('getMapCenter', e);
      return null;
    }
  }

  const getCurrentPosition = (): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  };

  const findMapCenter = async () => {
    console.log('findMapCenter');
    if (position?.lat && position?.lng) {
      map = getMapCenter(position.lat, position.lng);
      isShowMapCustom && showShopNote(map);
      return;
    }
    // Lấy vị trí hiện tại
    if (navigator.geolocation) {
      setIsLoading(true);
      try {
        const currentPosition = await getCurrentPosition();
        setPosition({
          lat: currentPosition.coords.latitude,
          lng: currentPosition.coords.longitude,
        });
        map = getMapCenter(
          currentPosition.coords.latitude,
          currentPosition.coords.longitude,
        );
      } catch (e) {
        map = getMapCenter(10.767644104951271, 106.6559225320816);
      } finally {
        setIsLoading(false);
      }
    } else map = getMapCenter(10.767644104951271, 106.6559225320816);
    isShowMapCustom && showShopNote(map);
  };

  const checkInOut = (item: any): number => {
    if (item?.id == 'A106_01') return 0; //chưa viếng thăm
    if (item?.id == 'A106_02') return 1; //đã viến thăm
    if (item?.id == 'A106_03') return 2; //khách vắng mặt
    return 1;
  };

  function calculateAndDisplayRoute(
    directionsService: google.maps.DirectionsService,
    directionsRenderer: google.maps.DirectionsRenderer,
    origin: any,
    destination: any,
    waypoints: any[] = [],
    travelMode: google.maps.TravelMode = google.maps.TravelMode.DRIVING,
    locationTeam: any,
    map: any,
  ) {
    // console.log('origin', origin);
    // console.log('destination', destination);
    // console.log('waypoints', waypoints);
    directionsService
      .route({
        origin: { lat: origin?.lat, lng: origin?.lng },
        destination: {
          lat: destination?.lat,
          lng: destination?.lng,
        },
        waypoints: (waypoints || []).map((waypoint: any) => ({
          location: { lat: waypoint?.lat, lng: waypoint?.lng },
        })),
        travelMode,
        optimizeWaypoints: true, // Tối ưu đường đi
      })
      .then((response) => {
        // console.log('calculateAndDisplayRoute response', response);
        directionsRenderer.setDirections(response);
        directionsRenderer.setMap(map);
      })
      .catch((e) => {
        console.log('calculateAndDisplayRoute e', e);
        directionsRenderer.setMap(null);
        map?.setCenter({
          lat: origin?.lat,
          lng: origin?.lng,
        });
      });
  }

  const createTagImg = (scale = 1.3): HTMLImageElement => {
    const docImg = document.createElement('img');
    docImg.style.width = '28px'; // Đặt chiều rộng của ảnh
    docImg.style.height = '28px';
    docImg.style.transform = `scale(${scale})`; // Sử dụng transform: scale để thay đổi kích thước ảnh
    docImg.style.transformOrigin = 'center';
    return docImg;
  };

  const createMaker = async ({
    location,
    isShowContent = false,
    isCustomer = true,
    isColseAll = false,
  }: {
    location: any;
    isShowContent?: boolean;
    isCustomer?: boolean;
    locationCenter?: any;
    isColseAll?: boolean;
  }) => {
    // console.log('location', location);
    // const flagImg = isCustomer ? createTagImg() : createTagImg(1.5);
    const flagImg = createTagImg();
    flagImg.src = isCustomer
      ? icons[checkInOut(location?.tprocessStatus)]
      : MarkerIcon;

    const marker = new advancedMarkerElementRef.current({
      map,
      position: { lat: location.lat, lng: location.lng },
      content: flagImg,
      title: isCustomer ? location.storeName || '' : location.name || '',
    });

    if (infoWindowsRef && infoWindowsRef.current) {
      const infoW = new google.maps.InfoWindow();

      if (isShowContent) {
        const contentDiv = document.createElement('div');
        const root = createRoot(contentDiv);

        root.render(
          isCustomer ? (
            <ContentCustomer value={location} />
          ) : (
            <ContentTeam value={location.name} />
          ),
        );
        infoW.setContent(contentDiv);
        infoW.open(marker.map, marker);
      }

      infoWindowsRef.current[location.id] = {
        infoWindow: infoW,
        isOpen: false,
        marker: marker,
      };

      marker.addListener('click', () => {
        const infoWindowState = infoWindowsRef.current[location.id];
        if (infoWindowState.isOpen) {
          infoWindowState.infoWindow.close();
          infoWindowState.isOpen = false;
        } else {
          isColseAll && closeAllInfoWindows();
          const contentDiv = document.createElement('div');
          const root = createRoot(contentDiv);
          root.render(
            isCustomer ? (
              <ContentCustomer value={location} />
            ) : (
              <ContentTeam value={location.name} />
            ),
          );
          infoWindowState.infoWindow.setContent(contentDiv);
          infoWindowState.infoWindow.open(marker.map, marker);
          infoWindowState.isOpen = true;
        }
      });
    }
  };

  const closeAllInfoWindows = () => {
    if (infoWindowsRef && infoWindowsRef.current) {
      Object.keys(infoWindowsRef.current).forEach((key) => {
        infoWindowsRef.current[key].infoWindow.close();
        infoWindowsRef.current[key].isOpen = false;
      });
    }
  };

  const deleteMarkers = () => {
    if (infoWindowsRef && infoWindowsRef.current) {
      Object.keys(infoWindowsRef.current).forEach((key) => {
        infoWindowsRef.current[key].marker.setMap(null);
      });
    }
  };

  const showShopNote = (map: any) => {
    const statusCustomerNode = document.createElement('div');
    statusCustomerNode.className = '!right-14 !bottom-4';
    createRoot(statusCustomerNode).render(<StatusCustomerNode />);
    map?.controls[google.maps.ControlPosition.BOTTOM_RIGHT].push(
      statusCustomerNode,
    );
  };

  return (
    <>
      <div
        id="map"
        ref={mapIdRef}
        className={`h-full bg-gray-300 ${isLoading && 'hidden'}`}
      />
      {/* <StatusCustomerNode /> */}
      {isLoading && (
        <Flex className={`h-full bg-gray-300`} justify="center" align="center">
          <LoadingOutlined style={{ fontSize: 50, color: 'white' }} />
        </Flex>
      )}
    </>
  );
};

export default GoogleMap;

const ContentTeam = (props: any) => {
  const Text = Typography;

  return (
    <Text
      className={`max-w-28 font-bold text-sm leading-4 !p-0 !m-0 text-wrap text-center`}
    >
      {props.value}
    </Text>
  );
};

const ContentCustomer = (props: any) => {
  const Text = Typography;
  const { value } = props;
  return (
    <Flex vertical>
      <Text
        className={`max-w-64 w-max font-bold text-sm leading-4 !p-0 !m-0 text-wrap text-left`}
      >
        {`${value.indexNum}. ${value.storeName}`}
      </Text>
      {/* Thông tin */}
      {value.element?.status == 'OK' && (
        <Space direction="vertical" size={0} className="mb-2">
          <Space size={5}>
            <TextCustom value={`- Khoảng cách: `} />
            <TextCustom
              value={value.element?.distance?.text || '-'}
              color="blueblack"
              weight="bold"
              isNumber
            />
          </Space>
          <Space size={5}>
            <TextCustom value={`- Thời gian đi: `} />
            <TextCustom
              value={value.element?.duration?.text || '-'}
              color="blueblack"
              weight="bold"
            />
          </Space>
        </Space>
      )}
      <Space size={5}>
        <TextCustom value={`Dự kiến: `} />
        <TextCustom
          value={value.averageRevenue || 0}
          color="blueblack"
          weight="bold"
          isNumber
        />
        <TextCustom value={`vnđ`} />
      </Space>
      {value.tcheckinout.map((item: any, index: number) => (
        <Space direction="vertical" size={0} className="mt-2" key={index}>
          <TextCustom
            value={`${formatDate(item.checkInTime, 'DD/MM/YYYY')}`}
            weight="bold"
          />
          <Space size={2}>
            <TextCustom value={`Lần ${index + 1}:`} color="text-[#757779]" />
            <TextCustom
              value={`${formatDate(item.checkInTime, 'HH:mm')} - ${item.checkOutTime ? formatDate(item.checkOutTime, 'HH:mm') : 'Chưa checkout'} ${calculateTimeDifferenceInMinutes(item.checkInTime, item.checkOutTime)}`}
            />
          </Space>
          <Flex gap={5}>
            <TextCustom value={`DT công: `} />
            <TextCustom
              value={item.totalProcessPrice || 0}
              color="red"
              weight="bold"
              isNumber
            />
            <TextCustom value={`vnđ`} />
          </Flex>
          <Flex gap={5}>
            <TextCustom value={`DT món: `} />
            <TextCustom
              value={item.totalProductPrice || 0}
              color="red"
              weight="bold"
              isNumber
            />
            <TextCustom value={`vnđ`} />
          </Flex>
        </Space>
      ))}
    </Flex>
  );
};

const StatusCustomerNode = () => {
  const [open, setOpen] = useState(true);
  const { MinusOutlined, PlusOutlined } = icons;
  return (
    <Space
      direction="vertical"
      align="start"
      size={5}
      className="bg-white p-1 my-2 rounded-md"
    >
      <Space size={5}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                defaultHoverBg: '#002f56c2',
              },
            },
          }}
        >
          <Button
            className="!p-1 !m-0 h-max bg-[#003056]"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <MinusOutlined
                className="text-white"
                style={{ fontSize: '10px' }}
              />
            ) : (
              <PlusOutlined
                className="text-white"
                style={{ fontSize: '10px' }}
              />
            )}
          </Button>
        </ConfigProvider>

        <TextCustom value="Chú giải" className="!text-[12px]" />
      </Space>
      {open && (
        <Space direction="vertical">
          <Space size={5}>
            <MarkerShopNoteBludIcon height={24} width={24} />
            <TextCustom className="!text-[12px]" value="Đã viếng thăm" />
          </Space>
          <Space size={5}>
            <MarkerShopNoteBrownIcon height={24} width={24} />
            <TextCustom className="!text-[12px]" value="Chưa viếng thăm" />
          </Space>
          <Space size={5}>
            <MarkerShopRedNoteIcon height={24} width={24} />
            <TextCustom className="!text-[12px]" value="Vắng/bận" />
          </Space>
        </Space>
      )}
    </Space>
  );
};
